import { OnboardingGrid } from "apps/commons/components/OnboardingGrid";
import { OneOnboardingSkeleton } from "apps/oneOnboarding/Skeleton";
import { SidebarSkeleton } from "apps/oneOnboarding/sidebar/Skeleton";

const OnboardIndexPage = () => {
    return <OnboardingGrid sidebar={<SidebarSkeleton />} content={<OneOnboardingSkeleton />} />;
};

export default OnboardIndexPage;
